import { Outlet, Link } from "react-router-dom";
import PoweredByDLSoft from "@/components/branding/PoweredByDLSoft";

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 via-primary-700 to-accent-700 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-mesh opacity-30" />
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-500/20 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="w-full max-w-md relative z-10">
        {/* Logo */}
        <div className="text-center mb-8 animate-fade-in-up">
          <div className="inline-flex items-center justify-center w-20 h-20 mb-4">
            <img
              src="/branding/insignia_icon.svg"
              alt="Insignia"
              className="w-full h-full drop-shadow-2xl"
            />
          </div>
          <h1 className="text-4xl font-bold text-white">Insignia</h1>
          <p className="text-primary-200 mt-2 text-lg">
            Sistema de gestión de clubes
          </p>
        </div>

        {/* Card */}
        <div
          className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 animate-fade-in-up"
          style={{ animationDelay: "100ms" }}
        >
          <Outlet />
        </div>

        {/* Footer */}
        <div
          className="mt-6 space-y-3 animate-fade-in"
          style={{ animationDelay: "200ms" }}
        >
          <p className="text-center text-primary-200 text-sm">
            © {new Date().getFullYear()} Insignia · Asociación del Oriente
            Colombiano
          </p>
          <div className="flex items-center justify-center gap-4 text-xs text-primary-200/80">
            <Link to="/terms" className="hover:text-white transition-colors">
              Términos
            </Link>
            <span className="text-primary-300/40">·</span>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacidad
            </Link>
          </div>
          <div className="flex justify-center pt-1">
            <PoweredByDLSoft theme="dark" variant="simple" size="sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
